/**
 * The brand, in one place. "KM Stories" became Qissakhana on 2026-10-15
 * (docs/rebrand/QISSAKHANA-MIGRATION.md, kept outside the repo for now).
 *
 * The Persian name is two words joined by U+200C ZERO WIDTH NON-JOINER after
 * the final he. Without it the he joins the khe and the name renders as one
 * run-together word; with a plain space it becomes two words. It is written as
 * an escape so it stays visible in source, and a test asserts it is there.
 *
 * Internal identifiers (the @kmstories/* npm scope, the database, the stack dir,
 * router names) deliberately keep the old name. Nobody outside the team sees them.
 */
export const BRAND_NAME = "Qissakhana";
export const BRAND_NAME_FA = "قصه\u200cخانه";
/** English tagline. The Persian name already means this, so it stands alone in FA. */
export const BRAND_TAGLINE = "House of Stories";

/**
 * The one public contact address: printed on the site, in the legal pages and
 * in emails. Mail at @qissakhana.com is not set up yet (no MX record as of
 * 2026-10-15), so this stays on lamtimoradi.se, which Postmark has verified.
 * Switching to the new domain is this one line, once the mailbox, MX, SPF and
 * the Postmark domain exist. kmstories@lamtimoradi.se must keep receiving
 * either way: it is printed in consent text v1 and in every receipt sent.
 */
export const CONTACT_EMAIL = "kmstories@lamtimoradi.se";

/** Default `From:` for outgoing mail (EMAIL_FROM overrides it). */
export const EMAIL_FROM_DEFAULT = `${BRAND_NAME} <${CONTACT_EMAIL}>`;
/** Default recipient of admin notifications (NOTIFY_TO overrides it). */
export const NOTIFY_TO_DEFAULT = CONTACT_EMAIL;

/**
 * The day the site moved to qissakhana.com and the legal pages started saying
 * so. A placeholder until the cutover is scheduled; set it on the day.
 */
export const RENAME_DATE = "2026-10-15";
